import React, { useState, useEffect } from 'react';
import { returnSymbolString } from "../Utils/utilFunctions";
import { loadOmbrelloniState, saveOmbrelloniState} from "../Utils/state";
import {E_MainMenus, 
  E_MainLato, 
  E_PedanaStepAltezza, 
  E_PedanaRivestimento, 
  E_TipoParavento, 
  E_GenereOmbrellone,
  E_TipoOmbrellone,  
  E_ColoriMetallo,
  E_ColoriTessuto,
  E_MisureOmbrelloni,
  E_ConfOmbrelloniContrapposti,
  E_KitLedOmbrelloni,} from "../Utils/enumerations";
  import {useSelector, useDispatch} from "react-redux";
  import {handleDarkTheme, handleMainMenu, handlePedanaMenu, handleParaventiMenu, handleOmbrelloniMenu, handleCristalMenu, handleCostoMenu} from "../../Redux/UIMenus/uiMenuStatesSlice";
  import {handleLunghezza, handleLarghezza, handleIngresso, handleColoreStrutture, handleCanDrawElements} from "../../Redux/UIMenus/uiMainMenuSlice";
  import {setPedanaMenuVisible,   
    handlePedanaStepAltezza,    
    handlePedanaRivestimento,
    handlePedanaMinigonna,
    handlePedanaRampaDisabili,
    handlePedanaPredParaventi,
    handlePedanaBotole} from "../../Redux/UIMenus/uiPedanaMenuSlice";
import {setParaventiMenuVisible,         
  handleParaventiTipo,
  handleParaventiLato,
  handleParaventiPorta,
  setLunghezzaParaventi} from "../../Redux/UIMenus/uiParaventiMenuSlice";
  import {setOmbrelloniMenuVisible,
    handleAutomaticMeasureSelection,
    handleGenereOmbrellone,
    handleOmbrelloniTipo,
    handleOmbrelloniDimensioni,
    handleOmbrelloniMantovana,
    handleOmbrelloniLato,   
    handleColoreTessutoOmbrelloni,
    handleOmbrelloniGrondaie,
    handleOmbrelloniNastratura,
    handleOmbrelloniVelcro,
    handleOmbrelloniDimensioneAuto,
    handleDataOmbrelloni,
    setOmbrelloniContrapposti,
    handleConfigurazioneContrapposti,
    setHasLed,
    handleKitLed,
    setHasDimmerTel,} from "../../Redux/UIMenus/uiOmbrelloniMenuSlice";
    import {setLateraleCristalMenuVisible,         
      handleLateraleCristalLato,
      handleKitPortaCristal,    
      setLunghezzaLateraleCristal,
  handleTotaleSostegni,} from "../../Redux/UIMenus/uiLateraleCristalMenuSlice";
import { handleTotale } from "../../Redux/UIMenus/uiCalcoloMenuSlice";
import Select, {components} from "react-select";
import {ombrelloniConfiguration} from "../Utils/meshesConfiguration";
import {CodiciColoreOmbrelloni} from "../Ombrelloni/CodiciColoreOmbrelloni";
import {IoIosArrowDown} from "react-icons/io";
import { BsFillSquareFill } from "react-icons/bs";
import { Compute } from "../../calcolatore/Calcolatore";
import ScreenShotButton from "../Export/ScreenShotButton";
import HomeButton from "../Export/HomeButton";
import { NumberWithCommas } from "../Utils/utilFunctions";

import "../../styles/UIConfigurator.css"

// Interfaccia pricipale
export default function UIConfigurator() {
  const mainMenuOpenState = useSelector(state => state.uiMenuState.mainMenuStateOpen);
  const pedanaMenuOpenState = useSelector(state => state.uiMenuState.pedanaMenuStateOpen);
  const paraventiMenuOpenState = useSelector(state => state.uiMenuState.paraventiMenuStateOpen);
  const ombrelloniMenuOpenState = useSelector(state => state.uiMenuState.ombrelloniMenuStateOpen);
  const cristalMenuOpenState = useSelector(state => state.uiMenuState.cristalMenuStateOpen);
  const costoMenuOpenState = useSelector(state => state.uiMenuState.costoMenuStateOpen);
  const mainLunghezza = useSelector(state => state.uiMainMenu.lunghezza);
  const mainLarghezza = useSelector(state => state.uiMainMenu.larghezza);
  const mainIngresso = useSelector(state => state.uiMainMenu.ingresso);
  const mainColoreStrutture = useSelector(state => state.uiMainMenu.coloreStrutture);
  const pedanaMenuVisible = useSelector(state => state.uiPedanaMenu.isVisible);
  const pedanaStepAltezza = useSelector(state => state.uiPedanaMenu.stepAltezza);
  const pedanaRivestimento = useSelector(state => state.uiPedanaMenu.rivestimento);
  const pedanaMinigonna = useSelector(state => state.uiPedanaMenu.minigonna);
  const pedanaRampaDisabili = useSelector(state => state.uiPedanaMenu.rampaDisabili);
  const pedanaPredParaventi = useSelector(state => state.uiPedanaMenu.predisposizioneParaventi);
  const pedanaNumeroBotole = useSelector(state => state.uiPedanaMenu.numeroBotole);
  const paraventiMenuVisible = useSelector(state => state.uiParaventiMenu.isVisible);
  const paraventoTipo = useSelector(state => state.uiParaventiMenu.tipoParavento);
  const paraventiLato = useSelector(state => state.uiParaventiMenu.latiParaventi);
  const paraventoPorta = useSelector(state => state.uiParaventiMenu.porta); 
  const paraventiLunghezza = useSelector(state => state.uiParaventiMenu.lunghezzaParaventi);
  const ombrelloniMenuVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
  const ombrelloniSelezioneMisAutomatica = useSelector(state => state.uiOmbrelloniMenu.selezioneMisuraAutomatica);
  const ombrelloniGenere = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
  const ombrelloneTipo = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
  const ombrelloniMantovana = useSelector(state => state.uiOmbrelloniMenu.mantovana);
  const ombrelloniMisure = useSelector(state => state.uiOmbrelloniMenu.misureOmbrellone);
  const ombrelloniMisuraAutomatica = useSelector(state => state.uiOmbrelloniMenu.misuraOmbrelloneAutomatica);
  const ombrelloniLato = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
  const ombrelloniColoreTessuto = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);
  const ombrelloniGrondaie = useSelector(state => state.uiOmbrelloniMenu.grondaie);
  const ombrelloniNumeroGrondaie = useSelector(state => state.uiOmbrelloniMenu.numeroGrondaie);
  const ombrelloniNastratura = useSelector(state => state.uiOmbrelloniMenu.nastratura);
  const ombrelloniVelcro = useSelector(state => state.uiOmbrelloniMenu.velcro);
  const ombrelloniData = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
  const ombrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
  const ombrelloniContrappostiConf = useSelector(state => state.uiOmbrelloniMenu.confOmbrelloniContrapposti);
  const ombrelloniHasLed = useSelector(state => state.uiOmbrelloniMenu.hasLed);
  const ombrelloniTipoKitLed = useSelector(state => state.uiOmbrelloniMenu.tipoKitLed);
  const ombrelloniHasDimmerTel = useSelector(state => state.uiOmbrelloniMenu.hasDimmerTel);
  const cristalMenuVisible = useSelector(state => state.uiCristalMenu.isVisible);
  const lateraleCristalLato = useSelector(state => state.uiCristalMenu.latiCristal);
  const lateraleCristalLunghezzaLati = useSelector(state => state.uiCristalMenu.lunghezzaCristal);
  const lateraleTotaleSostegni = useSelector(state => state.uiCristalMenu.totaleSostegni);
  const lateraleCristalKitPorta = useSelector(state => state.uiCristalMenu.kitPortaCristal);
  const prezzoTotale = useSelector(state => state.uiCalcoloMenu.totale);
  const darkTheme = useSelector(state => state.uiMenuState.darkTheme);
  
  const [ombrelloniTessutoTexturePath, setOmbrelloniTessutoTexturePath] = useState(`${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T15.png`)
  const [ombrelloniContrappostiUnavaible, setOmbrelloniContrappostiUnavaible] = useState(true);

  const dispatch = useDispatch();
  
  // apre e chiude i vari menu
  const handleCollapsableMenus = menuToOperate => {  
    switch(menuToOperate) {
      case E_MainMenus.Main:      
      dispatch(handleMainMenu());    
      break;
      case E_MainMenus.Pedana:
        dispatch(handlePedanaMenu());
        break;
      case E_MainMenus.Paraventi:
        dispatch(handleParaventiMenu());
        break;
      case E_MainMenus.Ombrelloni:
        dispatch(handleOmbrelloniMenu());
        break;
      case E_MainMenus.Cristal:
        dispatch(handleCristalMenu());
        break;
      case E_MainMenus.Costo:
        dispatch(handleCostoMenu());
        break;
      default:
        break;
    }
  }

  // Calcola il prezzo di continuo
  useEffect(
    () => {
      const total = Compute(
        pedanaMenuVisible,
        paraventiMenuVisible,
        ombrelloniMenuVisible,
        cristalMenuVisible,
        mainLunghezza,
        mainLarghezza,
        pedanaStepAltezza,
        pedanaRivestimento,
        pedanaMinigonna,
        pedanaRampaDisabili,
        pedanaPredParaventi,
        pedanaNumeroBotole,
        paraventiLunghezza,
        paraventoTipo,
        paraventoPorta,
        ombrelloniData.length > 0 && ombrelloniData.length,
        ombrelloneTipo, 
        ombrelloniSelezioneMisAutomatica,
        ombrelloniMisure,
        ombrelloniMisuraAutomatica,
        ombrelloniGrondaie,
        ombrelloniNastratura,
        ombrelloniVelcro,
        ombrelloniData.length > 0 && ombrelloniData,
        mainColoreStrutture,
        lateraleCristalLato,
        lateraleCristalLunghezzaLati,
        lateraleTotaleSostegni,
        lateraleCristalKitPorta,
        ombrelloniHasLed, 
        ombrelloniTipoKitLed,
        ombrelloniHasDimmerTel, 
        ombrelloniNumeroGrondaie
      );   
      dispatch(handleTotale(`${NumberWithCommas(total.toFixed(2))} €`));     
    }, [  
        mainLunghezza, 
        mainLarghezza, 
        mainIngresso, 
        mainColoreStrutture, 
        pedanaMenuVisible, 
        pedanaStepAltezza, 
        pedanaRivestimento, 
        pedanaMinigonna, 
        pedanaRampaDisabili, 
        pedanaPredParaventi, 
        pedanaNumeroBotole,
        paraventiMenuVisible, 
        paraventoTipo, 
        paraventiLato,
        paraventoPorta, 
        paraventiLunghezza, 
        ombrelloniMenuVisible, 
        ombrelloniSelezioneMisAutomatica,
        ombrelloniGenere, 
        ombrelloneTipo, 
        ombrelloniMantovana, 
        ombrelloniMisure, 
        ombrelloniMisuraAutomatica, 
        ombrelloniLato, 
        ombrelloniColoreTessuto,
        ombrelloniGrondaie, 
        ombrelloniNastratura, 
        ombrelloniVelcro, 
        ombrelloniData, 
        cristalMenuVisible, 
        lateraleCristalLato, 
        lateraleCristalLunghezzaLati,
        lateraleTotaleSostegni, 
        lateraleCristalKitPorta, 
        ombrelloniHasLed, 
        ombrelloniTipoKitLed,
        ombrelloniHasDimmerTel, 
        ombrelloniNumeroGrondaie
  ]);

  // Verifica la dimensione della lunghezza
  const handleLunghezzaCheck = (value) => {       
    if (value < 2) {
      dispatch(handleCanDrawElements(false));
    } else {
      dispatch(handleCanDrawElements(true));
    }
    dispatch(handleLunghezza(value));
  }
  // Verifica la dimensione della larghezza
  const handleLarghezzaCheck = (value) => {
    if (value < 2) {
      dispatch(handleCanDrawElements(false));
    } else {
      dispatch(handleCanDrawElements(true));
    }
    dispatch(handleLarghezza(value));
  }

  // Cambia il colore strutture ed il tema
  const changeColoreStrutture = (event) => {
    dispatch(handleColoreStrutture(event.target.value));
    // Cambia il tema
    if (event.target.value.toString() === E_ColoriMetallo.Antracite.toString()) {
      dispatch(handleDarkTheme(true));
    } else if (event.target.value.toString() === E_ColoriMetallo.Bianco.toString()) {
      dispatch(handleDarkTheme(false));
    }
  }

  // Salvataggio dello stato degli ombrelloni
  const saveOmbrelloniUI = (tipo, isAutomatica, misura, misuraAutomatica, lato) => {   
    // Se si tratta di ombrelloni a braccio o a sbalzo...
    if (ombrelloniGenere.toString() === E_GenereOmbrellone.Braccio.toString()) {   
      // Salva lo stato
      saveOmbrelloniState(E_GenereOmbrellone.Braccio, {
        genere: ombrelloniGenere,
        tipo: tipo,
        isAutomatica: isAutomatica,
        misura: misura,
        misuraAutomatica: misuraAutomatica,
        lato: lato, 
      });
    } else // Se si tratta di ombrelloni centrali...
    if (ombrelloniGenere.toString() === E_GenereOmbrellone.Centrale.toString()) {      
      // Salva lo stato
      saveOmbrelloniState(E_GenereOmbrellone.Centrale, {
        genere: ombrelloniGenere,
        tipo: tipo,
        isAutomatica: isAutomatica,
        misura: misura,
        misuraAutomatica: misuraAutomatica,   
      });
    } else // Se si tratta di ombrelloni a sbalzo...
    if (ombrelloniGenere.toString() === E_GenereOmbrellone.Sbalzo.toString()) {      
      // Salva lo stato
      saveOmbrelloniState(E_GenereOmbrellone.Sbalzo, {
        genere: ombrelloniGenere,
        tipo: tipo,
        isAutomatica: isAutomatica,
        misura: misura,
        misuraAutomatica: misuraAutomatica,   
        lato: lato, 
      });
    }            
  }

  // Caricamento dello stato degli ombrelloni
  const loadOmbrelloniUI = (stato) => {
    // Se si tratta di ombrelloni a braccio
    if (stato.toString() === E_GenereOmbrellone.Braccio.toString()) {    
      // Se lo stato non è vuoto..
      if (Object.keys(loadOmbrelloniState(E_GenereOmbrellone.Braccio)).length !== 0) {
        // Caricalo     
        dispatch(handleAutomaticMeasureSelection(loadOmbrelloniState(E_GenereOmbrellone.Braccio).isAutomatica));
        dispatch(handleOmbrelloniTipo(loadOmbrelloniState(E_GenereOmbrellone.Braccio).tipo));
        dispatch(handleOmbrelloniDimensioni(loadOmbrelloniState(E_GenereOmbrellone.Braccio).misura)); 
        dispatch(handleOmbrelloniLato(loadOmbrelloniState(E_GenereOmbrellone.Braccio).lato));
      } // Altrimenti resetta lo stato 
      else {
        resetOmbrelloniUI();
      }
    }
    //Se si tratta di ombrelloni a braccio
    else if (stato.toString() === E_GenereOmbrellone.Centrale.toString()) {   
      // Se lo stato non è vuoto..
      if (Object.keys(loadOmbrelloniState(E_GenereOmbrellone.Centrale)).length !== 0) {
        // Caricalo   
        dispatch(handleAutomaticMeasureSelection(loadOmbrelloniState(E_GenereOmbrellone.Centrale).isAutomatica));
        dispatch(handleOmbrelloniTipo(loadOmbrelloniState(E_GenereOmbrellone.Centrale).tipo));
        dispatch(handleOmbrelloniDimensioni(loadOmbrelloniState(E_GenereOmbrellone.Centrale).misura)); 
      } // Altrimenti resetta lo stato 
      else {
        resetOmbrelloniUI();
      }
    }
    // Se si tratta di ombrelloni a braccio
    else if (stato.toString() === E_GenereOmbrellone.Sbalzo.toString()) {      
      // Se lo stato non è vuoto..
      if (Object.keys(loadOmbrelloniState(E_GenereOmbrellone.Sbalzo)).length !== 0) {
        // Caricalo   
        dispatch(handleAutomaticMeasureSelection(loadOmbrelloniState(E_GenereOmbrellone.Sbalzo).isAutomatica));
        dispatch(handleOmbrelloniTipo(loadOmbrelloniState(E_GenereOmbrellone.Sbalzo).tipo));
        dispatch(handleOmbrelloniDimensioni(loadOmbrelloniState(E_GenereOmbrellone.Sbalzo).misura)); 
        dispatch(handleOmbrelloniLato(loadOmbrelloniState(E_GenereOmbrellone.Sbalzo).lato));
      } // Altrimenti resetta lo stato 
      else {
        resetOmbrelloniUI();
      }
    }   
  }

  // Reset dello stato degli ombrelloni
  const resetOmbrelloniUI = () => {
    dispatch(handleAutomaticMeasureSelection(true));   
    dispatch(handleOmbrelloniTipo(E_TipoOmbrellone.Scegli.toString()));
    dispatch(handleOmbrelloniDimensioni(E_MisureOmbrelloni.Scegli.toString())); 
    dispatch(handleOmbrelloniLato(E_MainLato.Scegli.toString()));  
    dispatch(setLateraleCristalMenuVisible(false));
  }

  // Cambia la tipologia di ombrelloni
  const handleGenereOmbrelloneChange = (genereTipo) => {  
    // Se è selezionato il velcro per gli ombrelloni centrali, lo deseleziona   
    if (genereTipo.toString() === E_GenereOmbrellone.Centrale.toString() && ombrelloniVelcro === true) {    
      dispatch(handleOmbrelloniVelcro(false));
    }  

    const actualGenere = genereTipo;
    const tipo = ombrelloneTipo;
    const isAutomatica = ombrelloniSelezioneMisAutomatica;
    const misura = ombrelloniMisure;
    const misuraAutomatica = ombrelloniMisuraAutomatica;
    const lato = ombrelloniLato;   
    // Carica lo stato corretto
    switch(actualGenere.toString()) {
      case E_GenereOmbrellone.Braccio.toString(): 
        loadOmbrelloniUI(E_GenereOmbrellone.Braccio);      
      break;
      case E_GenereOmbrellone.Centrale.toString():      
        loadOmbrelloniUI(E_GenereOmbrellone.Centrale);
      break;
      case E_GenereOmbrellone.Sbalzo.toString(): 
        loadOmbrelloniUI(E_GenereOmbrellone.Sbalzo); 
      break;
      default:
        loadOmbrelloniUI(E_GenereOmbrellone.Braccio);    
      break;
    } 
    // Salva il nuovo genere
    saveOmbrelloniUI(tipo, isAutomatica, misura, misuraAutomatica, lato);
 
    dispatch(handleGenereOmbrellone(genereTipo));
  }
  
  // Ritorna il tipo di ombrellone specifico in lista
  const getListaOmbrelloni = (tipo) => {  
    if (tipo.toString() === E_GenereOmbrellone.Braccio.toString()) {
      return (
      <>
        <option value={E_TipoOmbrellone.Scegli.toString()}>{returnSymbolString(E_TipoOmbrellone.Scegli.toString())}</option>
        {ombrelloniConfiguration.map((element,index) => {
        return element.meshGenere.toString() === E_GenereOmbrellone.Braccio.toString() &&                  
        <option key={`option_${index}`} value={element.meshSpecificName.toString()}>{        
          returnSymbolString(element.meshSpecificName.toString())}</option>
        })}
      </>);
    } else if (tipo.toString() === E_GenereOmbrellone.Centrale.toString()) {
      return (
        <>
          <option value={E_TipoOmbrellone.Scegli.toString()}>{returnSymbolString(E_TipoOmbrellone.Scegli.toString())}</option>
          {ombrelloniConfiguration.map((element,index) => {
          return element.meshGenere.toString() === E_GenereOmbrellone.Centrale.toString() &&                  
          <option key={`option_${index}`} value={element.meshSpecificName.toString()}>{        
            returnSymbolString(element.meshSpecificName.toString())}</option>
          })}
        </>);
    } else if (tipo.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
      return (
        <>
          <option value={E_TipoOmbrellone.Scegli.toString()}>{returnSymbolString(E_TipoOmbrellone.Scegli.toString())}</option>
          {ombrelloniConfiguration.map((element,index) => {
          return element.meshGenere.toString() === E_GenereOmbrellone.Sbalzo.toString() &&                  
          <option key={`option_${index}`} value={element.meshSpecificName.toString()}>{        
            returnSymbolString(element.meshSpecificName.toString())}</option>
          })}
        </>);   
    }                          
  }

  // Ritorna la lista degli ombrelloni a seconda del genere di ombrelloni selzionati
  const getTipoOmbrellone = () => {   
    //if (pedanaMenuVisible) {
      if (ombrelloniGenere.toString() === E_GenereOmbrellone.Braccio.toString()) {
        return getListaOmbrelloni(E_GenereOmbrellone.Braccio);
      } else if (ombrelloniGenere.toString() === E_GenereOmbrellone.Centrale.toString()) {
        return getListaOmbrelloni(E_GenereOmbrellone.Centrale);
      } else if (ombrelloniGenere.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
        return getListaOmbrelloni(E_GenereOmbrellone.Sbalzo);
      }     
  }

  // Setta le dimensioni degli ombrelloni a seconda del tipo di ombrellone specifico
  const getOmbrelloniDimensions = () => {  
    if (!ombrelloniSelezioneMisAutomatica) {     
      const ombrelloneArray = ombrelloniConfiguration.filter(element => element.meshSpecificName.toString() === ombrelloneTipo.toString());   
      if (ombrelloneArray.length > 0) {   
          return ombrelloneArray[0].meshDimensions.map(
          (element, index) => {           
            return <option key={`option_${index}`} value={element.toString()}>{returnSymbolString(element.toString())}</option>}
          );
      } else {
          return <option value={"Scegli"}>{"Scegli"}</option>; 
      }     
    } else {
      return <option>{returnSymbolString(ombrelloniMisuraAutomatica)}</option>
    }   
  }

  // Restituisce il codice colore dal tessuto dell'ombrellone
  const getColoreTessuto = codiceColore => {    
    const coloreSelezionato = CodiciColoreOmbrelloni.find(col => col.label.toString() === codiceColore.toString()); 
    return (
      {
        label: coloreSelezionato.label.toString(),
        texture: coloreSelezionato.texture,
        value: coloreSelezionato.value,
      }
    );    
  }

  // Restituisce la lista colori del tessuto dell'ombrellone
  const getListaColoriTessuto = () => {    
    const listaColori = CodiciColoreOmbrelloni.map(cod => (
      {label: cod.label.toString(),
       value: cod.value,   
       texture: cod.texture,
      }));   
    if (listaColori.length > 0) {
      return listaColori;
    }
  }

  // Restituisce l'opzione select con l'icona colore per il colore ombrelloni
  const {Option} = components;
  const IconOption = props => { 
    return (
    <Option {...props}>
      <div style={{display: "flex", gap: "5px", alignItems: "center"}}>
        <BsFillSquareFill color={props.data.value} style={{border: "1px solid #808080"}}/>
        <div>{returnSymbolString(props.data.label)}</div>
      </div>
    </Option>)  
  }

  // Gestisce le funzionalità paraventi
  const handleParaventi = (checked) => {
    // Se si preddispongono i paraventi ed è presente la pedana...
    if (checked && pedanaMenuVisible) {    
      // Predisposizione paraventi sì   
      if (pedanaPredParaventi === false) 
        dispatch(handlePedanaPredParaventi(true));
      dispatch(setParaventiMenuVisible(checked));   
    } else if (!checked && pedanaMenuVisible) {
      // Predisposizione paraventi no   
      if (pedanaPredParaventi === true) 
        dispatch(handlePedanaPredParaventi(false));
      dispatch(setParaventiMenuVisible(checked)); 
    }  
    else {     
      dispatch(setParaventiMenuVisible(checked));
    }  
  }

  // Gestisce le funzionalità pedana
  const handlePedana = (checked) => {
    // Se si preddispongono i paraventi ed è presente la pedana...
    if (checked && paraventiMenuVisible) {    
      // Predisposizione paraventi sì   
      if (pedanaPredParaventi === false) 
        dispatch(handlePedanaPredParaventi(true));
      dispatch(setPedanaMenuVisible(checked));   
    } else if (!checked && pedanaMenuVisible) {
      // Predisposizione paraventi no   
      if (pedanaPredParaventi === true) 
        dispatch(handlePedanaPredParaventi(false));
      dispatch(setPedanaMenuVisible(checked)); 
    }  
    else {     
      dispatch(setPedanaMenuVisible(checked));
    }  
  }

  // Gestisce le funzionalità laterale Cristal
  const handleCristal = (checked) => {
    if (checked) {
      dispatch(handleOmbrelloniMantovana(true));
      dispatch(handleOmbrelloniVelcro(true));
    } else {
      dispatch(handleOmbrelloniMantovana(false));
      dispatch(handleOmbrelloniVelcro(false));
    }
    dispatch(setLateraleCristalMenuVisible(checked));
  }

  // Gestisce le funzionalità tessuto ombrelloni
  const handleTessutoOmbrelloni = (event) => { 
    dispatch(handleColoreTessutoOmbrelloni(event.label));
    setOmbrelloniTessutoTexturePath(event.texture);  
  } 

  // Genera la lista dei tipi di kit led
  const selectKitLed = () => {
    const avaibleDimensions = [];
    if(ombrelloniData.length <= 0)
      return;
    const areaOmbrellone = ombrelloniData[0].mainDimension * ombrelloniData[0].secondaryDimension;
    const dimension = Math.sqrt(areaOmbrellone);
    if (dimension <= 4) {
      avaibleDimensions.push(E_KitLedOmbrelloni.kit0_5m.toString());
    }
    if (dimension >= 3) {
      avaibleDimensions.push(E_KitLedOmbrelloni.kit1m.toString());     
    }
    if (dimension >= 6) {
      avaibleDimensions.push(E_KitLedOmbrelloni.kit2m.toString());     
    }    
    return avaibleDimensions;
  }    
  
  // Verifica la possibilità di selezionare gli ombrelloni contrapposti
  useEffect(() => {    
    if (ombrelloniMenuVisible && 
        ombrelloniGenere.toString() !== E_GenereOmbrellone.Centrale.toString() &&
        ombrelloneTipo.toString() !== E_TipoOmbrellone.Scegli.toString() && 
        ombrelloniLato.toString() !== E_MainLato.Scegli.toString() 
        ) {
            if (!ombrelloniSelezioneMisAutomatica && ombrelloniMisure.toString() === E_MisureOmbrelloni.Scegli.toString()) {
              dispatch(setOmbrelloniContrapposti(false));
              setOmbrelloniContrappostiUnavaible(true);  
            }
            else if (ombrelloniSelezioneMisAutomatica || !ombrelloniSelezioneMisAutomatica && ombrelloniMisure.toString() !== E_MisureOmbrelloni.Scegli.toString()) {
              setOmbrelloniContrappostiUnavaible(false);
            }
        } else {
          dispatch(setOmbrelloniContrapposti(false));
          setOmbrelloniContrappostiUnavaible(true);
        }
  }, [ombrelloniMenuVisible, ombrelloniGenere, ombrelloneTipo, ombrelloniLato, ombrelloniMisure, ombrelloniSelezioneMisAutomatica]);

  
  // Resetta tutti i valori allo stato di partenza
  const handleReset = () => {
    dispatch(handleCanDrawElements(true));
    dispatch(handleLunghezza(2.0));
    dispatch(handleLarghezza(2.0));
    dispatch(handleIngresso(E_MainLato.Scegli.toString()));
    dispatch(handleColoreStrutture(E_ColoriMetallo.Antracite.toString()));
    dispatch(setPedanaMenuVisible(false));
    dispatch(handlePedanaStepAltezza(E_PedanaStepAltezza.Da0a50.toString()));
    dispatch(handlePedanaRivestimento(E_PedanaRivestimento.WPC.toString()));
    dispatch(handlePedanaMinigonna(true));
    dispatch(handlePedanaRampaDisabili(false));
    dispatch(handlePedanaPredParaventi(false));
    dispatch(handlePedanaBotole(0));
    dispatch(setParaventiMenuVisible(false));
    dispatch(handleParaventiTipo(E_TipoParavento.Slim_100.toString()));
    dispatch(handleParaventiLato([
      {lato: E_MainLato.Lato1.toString(),
      parav: false},
      {lato: E_MainLato.Lato2.toString(),
      parav: false},
      {lato: E_MainLato.Lato3.toString(),
      parav: false},
      {lato: E_MainLato.Lato4.toString(),
      parav: false},
    ],));
    dispatch(handleParaventiPorta(0));
    dispatch(setLunghezzaParaventi(0));
    dispatch(setOmbrelloniMenuVisible(false));
    dispatch(handleAutomaticMeasureSelection(true));
    dispatch(handleColoreTessutoOmbrelloni(E_ColoriTessuto.T15.toString()));
    dispatch(handleGenereOmbrellone(E_GenereOmbrellone.Braccio.toString()));
    dispatch(handleOmbrelloniTipo(E_TipoOmbrellone.Scegli.toString()));
    dispatch(handleOmbrelloniDimensioni(E_MisureOmbrelloni.Scegli.toString()));
    dispatch(handleOmbrelloniDimensioneAuto(E_MisureOmbrelloni.Automatica.toString()));
    dispatch(handleOmbrelloniLato(E_MainLato.Scegli.toString()));
    dispatch(handleOmbrelloniMantovana(false));
    dispatch(handleOmbrelloniGrondaie(false));
    dispatch(handleOmbrelloniNastratura(false));
    dispatch(handleOmbrelloniVelcro(false));
    dispatch(handleDataOmbrelloni([]));
    dispatch(setLateraleCristalMenuVisible(false));
    dispatch(handleLateraleCristalLato([
      {lato: E_MainLato.Lato1.toString(),
      cristal: false},
      {lato: E_MainLato.Lato2.toString(),
      cristal: false},
      {lato: E_MainLato.Lato3.toString(),
      cristal: false},
      {lato: E_MainLato.Lato4.toString(),
      cristal: false},
    ]));
    dispatch(setLunghezzaLateraleCristal([
      {lato: E_MainLato.Lato1.toString(),        
      lunghezzaCristalSulLato: 0},
      {lato: E_MainLato.Lato2.toString(),         
      lunghezzaCristalSulLato: 0},
      {lato: E_MainLato.Lato3.toString(),     
      lunghezzaCristalSulLato: 0},
      {lato: E_MainLato.Lato4.toString(),           
      lunghezzaCristalSulLato: 0},
    ]));
    dispatch(handleKitPortaCristal(false));
    dispatch(handleTotaleSostegni(0));  
    dispatch(setHasLed(false));
    dispatch(handleKitLed(E_KitLedOmbrelloni.kit0_5m.toString()));
    dispatch(setHasDimmerTel(false));
  } 
  
  return (      
    <div className='configurator' style={{backgroundColor: darkTheme ? "rgba(174, 204, 228, 0.9)" : "#ffffffa3"}}>  
     <div className='top_buttons_wrapper'>
        <div>
          <ScreenShotButton />    
        </div> 
        <div>
          <HomeButton />    
        </div>                
      </div>   
      <div>
          <div className='collapsable_element' onClick={_ => handleCollapsableMenus(E_MainMenus.Main)}>
            <IoIosArrowDown size={"24px"} color='orange'/>
            <div>MAIN MENU</div>
          </div>          
          {mainMenuOpenState && <>        
            <div className='element_line'>
              <label className='element_label'> Dimensioni: </label>
              <input name="lunghezza" className='element_input_value' type="number" step={0.01} value={mainLunghezza} min="2.0" onChange={event => handleLunghezzaCheck(event.target.value)} disabled={ombrelloniContrapposti}/>  
              <span>X</span><span  className="element_span"></span>
              <input name="larghezza" className='element_input_value' type="number" step={0.01} value={mainLarghezza} min="2.0" onChange={event => handleLarghezzaCheck(event.target.value)} disabled={ombrelloniContrapposti}/>
            </div>         
          <div className='element_line'>
            <label className='element_label'> Ingresso
              <select name="rampa" className='element_input' value={mainIngresso} onChange={event => dispatch(handleIngresso(event.target.value))}>
                <option value={E_MainLato.Scegli.toString()}>Scegli</option> 
                <option value={E_MainLato.Lato1.toString()}>LATO 1</option>
                <option value={E_MainLato.Lato2.toString()}>LATO 2</option>
                <option value={E_MainLato.Lato3.toString()}>LATO 3</option>
                <option value={E_MainLato.Lato4.toString()}>LATO 4</option> 
              </select>
            </label>
          </div>
          <div className='element_line'>
          <label className='element_label'>Colore strutture:
            <select name="colore-strutture" className='element_input' value={mainColoreStrutture} onChange={event => changeColoreStrutture(event)}>
              <option value={E_ColoriMetallo.Antracite.toString()}>Antracite</option>
              <option value={E_ColoriMetallo.Bianco.toString()}>Bianco</option>
            </select>
          </label>
        </div>
          <div className='element_line'>
            <label className='element_label'>PEDANA:
              <input type="checkbox" name="pedanaVisibleCheck" checked={pedanaMenuVisible} onChange={event => handlePedana(event.target.checked)} />
            </label>
          </div> 
          <div className='element_line'>
            <label className='element_label'>PARAVENTI:
              <input type="checkbox" name="paraventiVisibleCheck" checked={paraventiMenuVisible} onChange={event => handleParaventi(event.target.checked)} />
            </label>
          </div>  
          <div className='element_line'>
            <label className='element_label'>OMBRELLONI:
              <input type="checkbox" name="ombrelloniVisibleCheck" checked={ombrelloniMenuVisible} onChange={event => dispatch(setOmbrelloniMenuVisible(event.target.checked))}/>
            </label>
          </div>     
          <div className='element_line'>
            <label className='element_label'>CRISTAL:
              <input type="checkbox" name="cristalVisibleCheck" checked={cristalMenuVisible} onChange={event => handleCristal(event.target.checked)}/>
            </label>
          </div>        
        </>}       
        {pedanaMenuVisible && <div>
         <div className='collapsable_element' onClick={_ => handleCollapsableMenus(E_MainMenus.Pedana)}>
           <IoIosArrowDown size={"24px"} color='orange'/>
           <div>PEDANA</div>
         </div>
        {pedanaMenuOpenState && <> 
         <div className='element_line'>
           <label className='element_label'>Step Altezza
             <select name="altezza" className='element_input' value={pedanaStepAltezza} onChange={event => dispatch(handlePedanaStepAltezza(event.target.value))}>
               <option value={E_PedanaStepAltezza.Da0a50.toString()}>Scegli</option>
               <option value={E_PedanaStepAltezza.Da50a95.toString()}>Da 50 a 95mm</option>
               <option value={E_PedanaStepAltezza.Da95a125.toString()}>Da 95 a 125mm</option>
               <option value={E_PedanaStepAltezza.Da125a250.toString()}>Da 125 a 250mm</option>
             </select>
           </label>
         </div>
         <div className='element_line'>
           <label className='element_label'>Rivestimento
             <select name="rivestimento" className='element_input' value={pedanaRivestimento} onChange={event => dispatch(handlePedanaRivestimento(event.target.value))}>
               <option value={E_PedanaRivestimento.WPC.toString()}>WPC</option>
               <option value={E_PedanaRivestimento.ANGELIM.toString()}>ANGELIM</option>
             </select>
           </label>
         </div>
         <div className='element_line'>
           <label className='element_label'> Minigonna
             <input type="checkbox" name="minigonnaCheck" checked={pedanaMinigonna} onChange={event => dispatch(handlePedanaMinigonna(event.target.checked))}/>
           </label>
         </div>       
         <div className='element_line'>
           <label className='element_label'> Rampa disabili
             <input type="checkbox" name="rampaCheck" checked={pedanaRampaDisabili} onChange={event => dispatch(handlePedanaRampaDisabili(event.target.checked))} disabled={mainIngresso.toString() === E_MainLato.Scegli.toString()}/>
           </label>
         </div>
         <div className='element_line'>
           <label className='element_label'> Pred. Paraventi
             <input type="checkbox" name="paraventiCheck" checked={pedanaPredParaventi} onChange={event => dispatch(handlePedanaPredParaventi(event.target.checked))} disabled={paraventiMenuVisible}/>
           </label>
         </div>
         <div className='element_title'>BOTOLA</div>
         <div className='element_line'>
           <label className='element_label'> Numero botole
             <select name="num-botole" className='element_input' value={pedanaNumeroBotole} onChange={event => dispatch(handlePedanaBotole(event.target.value))}>
               <option value={0}>0</option>
               <option value={1}>1</option>
               <option value={2}>2</option>
               <option value={3}>3</option>
             </select>
           </label>
         </div>        
       </>} 
    </div>}  
    {paraventiMenuVisible && <div>
      <div className='collapsable_element' onClick={_ => handleCollapsableMenus(E_MainMenus.Paraventi)}>
          <IoIosArrowDown size={"24px"} color='orange' />
          <div>PARAVENTI</div>
      </div>
      {paraventiMenuOpenState && <>
        <div className='element_line'>
          <label className='element_label'>Tipo Paravento
            <select name="tipo-paravento" className='element_input' value={paraventoTipo} onChange={event => dispatch(handleParaventiTipo(event.target.value))} >
              <option value={E_TipoParavento.Slim_100.toString()}>Slim h.100</option>
              <option value={E_TipoParavento.Unico_100.toString()}>Unico h.100</option>
              <option value={E_TipoParavento.Unico_150.toString()}>Unico h.150</option>
              <option value={E_TipoParavento.Smeraldo.toString()}>Smeraldo h.150</option>
              <option value={E_TipoParavento.Rubino.toString()}>Rubino h.150+20</option>
              <option value={E_TipoParavento.Topazio.toString()}>Topazio h.150</option>
              <option value={E_TipoParavento.Screen_Up_100.toString()}>Screen-Up (escluso da preventivo)</option>
            </select>
          </label>
        </div>
        <div className='element_line'>
          <label className='element_label'>Lato Paraventi:
            <div className='element_line'>
              <label className='element_value'>1
                <input type="checkbox" name="paraventiCheck1" checked={paraventiLato[(paraventiLato.findIndex(element => E_MainLato.Lato1.toString() === element.lato.toString()))].parav} onChange={event => dispatch(handleParaventiLato({lato: E_MainLato.Lato1.toString(), parav: event.target.checked}))} />
              </label>
              <label className='element_value'>2
                <input type="checkbox" name="paraventiCheck2" checked={paraventiLato[(paraventiLato.findIndex(element => E_MainLato.Lato2.toString() === element.lato.toString()))].parav} onChange={event => dispatch(handleParaventiLato({lato: E_MainLato.Lato2.toString(), parav: event.target.checked}))} />
              </label>
              <label className='element_value'>3
                <input type="checkbox" name="paraventiCheck3" checked={paraventiLato[(paraventiLato.findIndex(element => E_MainLato.Lato3.toString() === element.lato.toString()))].parav} onChange={event => dispatch(handleParaventiLato({lato: E_MainLato.Lato3.toString(), parav: event.target.checked}))} />
              </label>
              <label className='element_value'>4
                <input type="checkbox" name="paraventiCheck4" checked={paraventiLato[(paraventiLato.findIndex(element => E_MainLato.Lato4.toString() === element.lato.toString()))].parav} onChange={event => dispatch(handleParaventiLato({lato: E_MainLato.Lato4.toString(), parav: event.target.checked}))} />
              </label> 
            </div>
          </label>
        </div>
        <div className="element_line_row">
          <div className='element_title'>Lunghezza perimetro:</div>
          <div className='element_title'>{paraventiLunghezza}</div> 
        </div>        
        <div className='element_line'>
          <label className='element_label'>Porta
            <select name="kit-porta" className='element_input' value={paraventoPorta} onChange={event => dispatch(handleParaventiPorta(event.target.value * 1))}>
              <option value={0}>NO</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
            </select>
          </label>        
        </div>   
        </>}
      </div>}  
      {ombrelloniMenuVisible && <div>
        <div className='collapsable_element' onClick={_ => handleCollapsableMenus(E_MainMenus.Ombrelloni)}>
          <IoIosArrowDown size={"24px"} color='orange' />
          <div>OMBRELLONI</div>
        </div>
        {ombrelloniMenuOpenState && <>
        <div className='element_line'>
          <label className='element_label'>Genere
            <select name="genere" className='element_input' value={ombrelloniGenere} onChange={event => handleGenereOmbrelloneChange(event.target.value)} disabled={ombrelloniContrapposti}>
              <option value={E_GenereOmbrellone.Braccio.toString()}>Braccio</option>
              <option value={E_GenereOmbrellone.Centrale.toString()}>Palo centrale</option>  
              <option value={E_GenereOmbrellone.Sbalzo.toString()}>Sbalzo</option>   
            </select>
          </label>
        </div>
        <div>    
        {ombrelloniGenere ===E_GenereOmbrellone.Braccio.toString() ? <div className='element_title'>BRACCIO</div> : (ombrelloniGenere ===E_GenereOmbrellone.Centrale.toString() ? <div className='element_title'>PALO CENTRALE</div> : <div className='element_title'>SBALZO</div>)}
        <div className='element_line'>
          <label className='element_label'>Tipo ombrellone
            <select name="tipoSpecifico" className='element_input' value={ombrelloneTipo} onChange={event => dispatch(handleOmbrelloniTipo(event.target.value))} disabled={ombrelloniContrapposti}>
              {getTipoOmbrellone()}
            </select>
          </label>
        </div>     
        <div className='element_line'>
          <label className='element_label'>Seleziona Misura Automatica
            <input type="checkbox" name="ombrelloniSelezioneMisureCheck" checked={ombrelloniSelezioneMisAutomatica} onChange={event => dispatch(handleAutomaticMeasureSelection(event.target.checked))} disabled={ombrelloniContrapposti}/>
          </label>
        </div>         
        <div className='element_line'>
          <label className='element_label'>Misure Ombrelloni
            <select name="misure-ombrellone" className='element_input' value={ombrelloniMisure} onChange={ event => dispatch(handleOmbrelloniDimensioni(event.target.value))} disabled={ombrelloniSelezioneMisAutomatica || ombrelloniContrapposti}>
              {getOmbrelloniDimensions()}           
            </select>
          </label>
        </div>  
        {ombrelloniSelezioneMisAutomatica && ombrelloniData.length > 0 && <div className='element_line_row'>
          <div className='element_title'>SU MISURA:</div>
          <div className='element_title'><span>{ombrelloniData[0].realDimension.toFixed(2)}</span><span className="element_span">X</span><span>{ombrelloniData[0].secondaryDimension}</span></div> 
        </div>}      
        {(ombrelloniGenere === E_GenereOmbrellone.Braccio.toString() || ombrelloniGenere === E_GenereOmbrellone.Sbalzo.toString()) && <>              
          <div className='element_line'>
            <label className='element_label'>Lato Ombrellone              
              <select name="lato_ombrelloni" className='element_input' value={ombrelloniLato} onChange={event => dispatch(handleOmbrelloniLato(event.target.value))} disabled={ombrelloniContrapposti}>
                <option value={E_MainLato.Scegli.toString()}>-Scegli-</option>
                <option value={E_MainLato.Lato1.toString()}>Lato 1</option>
                <option value={E_MainLato.Lato2.toString()}>Lato 2</option>
                <option value={E_MainLato.Lato3.toString()}>Lato 3</option>
                <option value={E_MainLato.Lato4.toString()}>Lato 4</option>    
              </select>
            </label>
          </div>         
        </>}          
        </div>        
        <div className='element_line'>
          <label className='element_label'>Colore tessuto:
              <Select               
                onChange={event => handleTessutoOmbrelloni(event)}
                defaultValue={getColoreTessuto(ombrelloniColoreTessuto)}
                options={getListaColoriTessuto()}
                components={{Option: IconOption}}         
                className='element_input'
                styles={{ control: (baseStyles, state) => ({
                  ...baseStyles,               
                  borderColor: state.isFocused ? "#808080" : "#808080",                  
                  height: 20,
                  minHeight: 20,
                  borderRadius: "3px",
                  boxShadow: state.isFocused ? null : null,
                  padding: 0,  
                  "&:hover": {
                    borderColor: "black"
                  } 
                }), dropdownIndicator: () => ({            
                  transform: "scale(0.75)",
                  color: "black",
                  width: 20,           
                }), valueContainer: () => ({            
                  height: 18,          
                })
              }}
              />            
            <div style={{backgroundImage: `url(${ombrelloniTessutoTexturePath})`, backgroundRepeat: "no-repeat", width: "50px", height: "30px", border: "1px solid #808080", borderRadius: "4px", marginRight: "15px"}} /> 
          </label>          
        </div> 
        <div className='element_line'>
          <label className='element_label'>Mantovana
            <input type="checkbox" name="ombrelloniMantovanaCheck" checked={ombrelloniMantovana} onChange={event => dispatch(handleOmbrelloniMantovana(event.target.checked))} disabled={cristalMenuVisible} />
          </label>
        </div>  
        <div className='element_line'>
          <label className='element_label'>Grondaie
            <input type="checkbox" name="ombrelloniGrondaieCheck" checked={ombrelloniGrondaie} onChange={event => dispatch(handleOmbrelloniGrondaie(event.target.checked))} />
          </label>
        </div>  
        <div className='element_line'>
          <label className='element_label'>Nastratura/Cuciture
            <input type="checkbox" name="ombrelloniNastraturaCheck" checked={ombrelloniNastratura} onChange={event => dispatch(handleOmbrelloniNastratura(event.target.checked))} />
          </label>
        </div> 
        <div className='element_line'>
          <label className='element_label'>Velcro agganci per laterali/grondaie
            <input type="checkbox" name="ombrelloniVelcroCheck" checked={ombrelloniVelcro} onChange={event => dispatch(handleOmbrelloniVelcro(event.target.checked))} disabled={ombrelloniGrondaie || cristalMenuVisible}/>
          </label>
        </div>
        <div className='element_line'>
          <label className='element_label'>Ombrelloni contrapposti
            <input type="checkbox" name="ombrelloniContrappostiCheck" checked={ombrelloniContrapposti} onChange={event => dispatch(setOmbrelloniContrapposti(event.target.checked))} disabled={ombrelloniContrappostiUnavaible}/>
          </label>
        </div>
        {/* {ombrelloniContrapposti &&
        <div className='element_line'>
          <label className='element_label'>Configurazione contrapposti
            <select name="conf_contrapposti" className='element_input' value={ombrelloniContrappostiConf} onChange={event => dispatch(handleConfigurazioneContrapposti(event.target.value))}>
              <option value={E_ConfOmbrelloniContrapposti.InLinea.toString()}>Conf. in linea</option>
              <option value={E_ConfOmbrelloniContrapposti.Compatta.toString()}>Conf. compatta</option>             
            </select>
          </label>
        </div>} */}
        <div className='element_line'>
          <label className='element_label'>Led
            <input type="checkbox" name="ombrelloniContrappostiCheck" checked={ombrelloniHasLed} onChange={event => dispatch(setHasLed(event.target.checked))}/>
          </label>
        </div>
        {ombrelloniHasLed && ombrelloniData.length > 0 &&  <div className='element_line'>
          <label className='element_label'>Kit Led
            <select name="conf_Kit_led" className='element_input' value={ombrelloniTipoKitLed} onChange={event => dispatch(handleKitLed(event.target.value))}>
              {selectKitLed().map((element, val) => (              
                <option key={`led_kit_element_${val}`} value={element}>{returnSymbolString(element)}</option>              
              ))}         
            </select>
          </label>
        </div>}
        {ombrelloniHasLed && ombrelloniTipoKitLed !== null && ombrelloniTipoKitLed !== E_KitLedOmbrelloni.kit0_5m.toString() && <div className='element_line'>
          <label className='element_label'>Dimmer + Telecomando
              <input type="checkbox" name="ombrelloniDimmerCheck" checked={ombrelloniHasDimmerTel} onChange={event => dispatch(setHasDimmerTel(event.target.checked))}/>
            </label>
          </div>}
            <br/>       
          </>}
        </div>}    
        {cristalMenuVisible && <div>
        <div className='collapsable_element' onClick={_ => handleCollapsableMenus(E_MainMenus.Cristal)}>
          <IoIosArrowDown size={"24px"} color='orange' />
          <div>LATERALE CRISTAL</div>
        </div>
          {cristalMenuOpenState && <>
            <div className='element_line'>
              <label className='element_label'>Laterale Cristal:
                <div className='element_line'>
                  <label className='element_value'>1
                    <input type="checkbox" disabled={ombrelloniData.length <= 0} name="cristalCheck" checked={lateraleCristalLato[(lateraleCristalLato.findIndex(element => E_MainLato.Lato1.toString() === element.lato.toString()))].cristal} onChange={event => dispatch(handleLateraleCristalLato({lato: E_MainLato.Lato1.toString(), cristal: event.target.checked}))} />
                  </label>
                  <label className='element_value'>2
                    <input type="checkbox" disabled={ombrelloniData.length <= 0} name="cristalCheck" checked={lateraleCristalLato[(lateraleCristalLato.findIndex(element => E_MainLato.Lato2.toString() === element.lato.toString()))].cristal} onChange={event => dispatch(handleLateraleCristalLato({lato: E_MainLato.Lato2.toString(), cristal: event.target.checked}))} />
                  </label>
                  <label className='element_value'>3
                    <input type="checkbox" disabled={ombrelloniData.length <= 0} name="cristalCheck" checked={lateraleCristalLato[(lateraleCristalLato.findIndex(element => E_MainLato.Lato3.toString() === element.lato.toString()))].cristal} onChange={event => dispatch(handleLateraleCristalLato({lato: E_MainLato.Lato3.toString(), cristal: event.target.checked}))} />
                  </label>
                  <label className='element_value'>4
                    <input type="checkbox" disabled={ombrelloniData.length <= 0} name="cristalCheck" checked={lateraleCristalLato[(lateraleCristalLato.findIndex(element => E_MainLato.Lato4.toString() === element.lato.toString()))].cristal} onChange={event => dispatch(handleLateraleCristalLato({lato: E_MainLato.Lato4.toString(), cristal: event.target.checked}))} />
                  </label> 
                </div>
              </label>
            </div>  
            <div >
              <div className='element_line'>               
                  <label className='element_label'>Kit Porta Cristal
                    <input type="checkbox" disabled={ombrelloniData.length <= 0} name="kitPortaCristalCheck" checked={lateraleCristalKitPorta} onChange={event => dispatch(handleKitPortaCristal(event.target.checked))} />
                  </label>             
              </div>
            </div>  
            <br/>       
          </>}
        </div>}    
      </div>
      <div>
        <div className='collapsable_element' onClick={() => {handleCollapsableMenus(E_MainMenus.Costo)}}>
          <IoIosArrowDown size={"24px"} color='orange' />
          <div>TOTALE</div>
        </div>
        {costoMenuOpenState && <>
        <div className='element_line'>         
            <div className='element_title_big'>{prezzoTotale}</div>   
            <div className='button_container'>
              <button className="button" onClick={() => {handleReset()}}>RESET</button>
          </div>    
        </div>       
      </>}
      </div>           
    </div>  
  )
}